module.exports = __webpack_public_path__ + "static/IMG_6116-68604e8500f2c4f24de0d65f9b3c8add.jpg";